import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';

export function MarkSubscript(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;

    return <sub {...attributes}>{children}</sub>;
}
